// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.carousel {
  position: relative;
  width: 30rem;
  height: 30rem;
  perspective: 500px;
  transform-style: preserve-3d;
}

.card-container {
  position: absolute;
  width: 100%;
  height: 450px;
  transform: rotateY(calc(var(--offset) * 50deg)) scaleY(calc(1 + var(--abs-offset) * -0.4)) translateZ(calc(var(--abs-offset) * -30rem)) translateX(calc(var(--direction) * -5rem));
  filter: blur(calc(var(--abs-offset) * 1rem));
  transition: all 0.3s ease-out;
  border-radius: 1rem;
}

.card {
  background-color: #8B5CF6;
  width: 100%;
  height: 100%;
  padding: 2rem;
  border-radius: 1rem;
  color: #9CA3AF;
  text-align: justify;
  transition: all 0.3s ease-out;
}
.card h2 {
  text-align: center;
  font-size: 1.5rem;
  font-weight: bold;
  margin: 0 0 0.7em;
  color: white;
}
.card p {
  color: #ffffff;
}
.card p,
.card h2 {
  transition: all 0.3s ease-out;
}

.nav {
  color: white;
  font-size: 5rem;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 50%;
  z-index: 2;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background: unset;
  border-radius: 1rem;
  border: unset;
}
.nav.left {
  transform: translateX(-100%) translatey(-50%);
}
.nav.right {
  right: 0;
  transform: translateX(100%) translatey(-50%);
}

@media (max-width: 768px) {
  .carousel {
    width: 25rem;
    height: 25rem;
    perspective: 0px;
  }
  .card {
    -webkit-line-clamp: 1;
    overflow: hidden;
    transition: all 1s ease-in;
  }
  .card p {
    font-size: 14px;
  }
  .nav {
    font-size: 2rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/NewCrousel/NewCrousel.scss"],"names":[],"mappings":"AAOA;EACE,kBAAA;EACA,YALU;EAMV,aANU;EAOV,kBAAA;EACA,4BAAA;AANF;;AASA;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,kLACE;EACF,4CAAA;EACA,6BAAA;EACA,mBAAA;AAPF;;AAUA;EACI,yBAAA;EAEF,WAAA;EACA,YAAA;EACA,aAAA;EAEA,mBAAA;EACA,cAhCW;EAiCX,mBAAA;EACA,6BAAA;AATF;AAWE;EACE,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EAEA,YAAA;AAVJ;AAaE;EACE,cAAA;AAXJ;AAcE;;EAEE,6BAAA;AAZJ;;AAgBA;EACE,YAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;AAbF;AAeE;EACE,6CAAA;AAbJ;AAgBE;EACE,QAAA;EACA,4CAAA;AAdJ;;AAkBA;EACE;IACE,YAAA;IACA,aAAA;IACA,gBAAA;EAfF;EAkBA;IACE,qBAAA;IACA,gBAAA;IACA,0BAAA;EAhBF;EAkBE;IACE,eAAA;EAhBJ;EAoBA;IACE,eAAA;EAlBF;AACF","sourcesContent":["$color-purple: #8B5CF6;\n$color-pink: #EC4899;\n$color-gray: #9CA3AF;\n$color-black: #090922;\n$card-size: 30rem;\n\n\n.carousel {\n  position: relative;\n  width: $card-size;\n  height: $card-size;\n  perspective: 500px;\n  transform-style: preserve-3d;\n}\n\n.card-container {\n  position: absolute;\n  width: 100%;\n  height: 450px;\n  transform:\n    rotateY(calc(var(--offset) * 50deg)) scaleY(calc(1 + var(--abs-offset) * -0.4)) translateZ(calc(var(--abs-offset) * -30rem)) translateX(calc(var(--direction) * -5rem));\n  filter: blur(calc(var(--abs-offset) * 1rem));\n  transition: all 0.3s ease-out;\n  border-radius: 1rem;\n}\n\n.card {\n    background-color: #8B5CF6;\n\n  width: 100%;\n  height: 100%;\n  padding: 2rem;\n  // background-color: hsl(280deg, 40%, calc(100% - var(--abs-offset) * 50%));\n  border-radius: 1rem;\n  color: $color-gray;\n  text-align: justify;\n  transition: all 0.3s ease-out;\n\n  h2 {\n    text-align: center;\n    font-size: 1.5rem;\n    font-weight: bold;\n    margin: 0 0 0.7em;\n    // color: $color-black;\n    color:white\n  }\n\n  p {\n    color: #ffffff;\n  }\n\n  p,\n  h2 {\n    transition: all 0.3s ease-out;\n  }\n}\n\n.nav {\n  color: white;\n  font-size: 5rem;\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  top: 50%;\n  z-index: 2;\n  cursor: pointer;\n  user-select: none;\n  background: unset;\n  border-radius: 1rem;\n  border: unset;\n\n  &.left {\n    transform: translateX(-100%) translatey(-50%);\n  }\n\n  &.right {\n    right: 0;\n    transform: translateX(100%) translatey(-50%);\n  }\n}\n\n@media (max-width: 768px) {\n  .carousel {\n    width: 25rem;\n    height: 25rem;\n    perspective: 0px;\n  }\n\n  .card {\n    -webkit-line-clamp: 1;\n    overflow: hidden;\n    transition: all 1s ease-in;\n\n    p {\n      font-size: 14px;\n    }\n  }\n\n  .nav {\n    font-size: 2rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
